// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"Logo_logoLink__ctuMY","desktopLogo":"Logo_desktopLogo__2TgsJ","mobileLogo":"Logo_mobileLogo__1kFdT"};